import InsightsAgendaItem from './InsightsAgendaItem';

export { type InsightsAgendaItemProps } from './InsightsAgendaItem';
export default InsightsAgendaItem;
